// extracted by mini-css-extract-plugin
export default {"label":"vHNr7","dateContainer":"RcFzG","dateInput":"gv_fv"};